module.exports = __webpack_public_path__ + "img/27.74f3a6f6.webp";